const AbstractVerifoneConstantList = require('./AbstractVerifoneConstantList');

class VerifoneActionList extends AbstractVerifoneConstantList {
    /**
     * @param {string} name
     *
     * @return {{id: number, message: string, parameters?:string[]}}|undefined}
     */
    findByName(name) {
        return super.findByName(name);
    }

    /**
     * @param {number} id
     *
     * @return {string}
     */
    findNameById(id) {
        return super.findNameById(id);
    }
}

module.exports = VerifoneActionList;
